import { EventPostScore } from './EventPostScore';

export default EventPostScore;
